var Student = "学生";
var jobRole = {
	"Job role": "職種",
	"Academic / Researcher": "教育機関/研究者",
	"Advisor / Consultant": "アドバイザー/コンサルタント",
	"Business Executive": "企業幹部",
	"Developer / Engineer": "デベロッパー/エンジニア",
	"Entrepreneur (Founder/Co-Founder)": "起業家 (創設者/共同創設者)",
	"IT Executive": "IT 幹部",
	"IT Professional or Technical Manager": "IT 専門家または技術管理職",
	"Press / Media Analyst": "報道/メディアアナリスト",
	"Sales / Marketing": "セールス/マーケティング",
	Student: Student,
	"Solution or Systems Architect": "ソリューションまたはシステムアーキテクト",
	"System Administrator": "システム管理者",
	"Venture Capitalist": "投資家"
};

export { Student, jobRole as default };
